import { useLockBodyScroll } from '@/hooks';
import { useOutsideClick } from '@/hooks/useOutsideClick';
import { Icons } from '@/utils/Icons';

type Props = {
  open: boolean;
  onClose: () => void;
};

const AgeRestrictionModal = ({ open, onClose }: Props) => {
  useLockBodyScroll(open);
  const modalRef = useOutsideClick<HTMLDivElement>(() => {
    if (open) onClose();
  }, open);
  if (!open) return null;
  const appUrl = 'allpanelexch9.com';

  return (
    <div className="fixed inset-0 z-[60] flex justify-center bg-black/60 overflow-y-auto py-[1vh]">
      {/* Modal */}
      <div
        ref={modalRef}
        className="w-[500px] bg-white shadow-xl relative transform transition-all duration-300 ease-out animate-slide-in-from-top"
      >
        {/* Header */}
        <div
          className="h-[50px] px-4 flex items-center justify-between
          bg-primary text-white"
        >
          <h2 className="font-bold text-[20px]">{appUrl}</h2>

          <button onClick={onClose}>
            <Icons.Cross className="w-5 h-5 text-white" />
          </button>
        </div>

        {/* Content */}
        <div className="px-[67px] py-8 space-y-8 max-h-[calc(98vh-50px)] overflow-y-auto">
          {/* Over 18 Section */}
          <div className="space-y-2">
            <img src="/images/18plus.png" alt="18+" className="w-[30px] h-[30px]" />

            <h3 className="font-bold text-[16px]">Over 18s only</h3>

            <p className="text-[16px] leading-[19px]">
              It is an offence for anyone under the age of 18 to open an account or to gamble on{' '}
              {appUrl}. {appUrl} takes its age-verification responsibilities very seriously. We
              carry out age-verification checks on all customers who use payment mechanisms which
              are available to under 18s and additionally perform random age-verification checks on
              customers using other forms of funding mechanisms. We may ask for information to
              verify your age and could restrict or suspend your account until your age is
              confirmed.
            </p>

            <p className="text-[16px] leading-[19px]">
              PLEASE NOTE THAT ANYONE UNDER THE AGE OF 18 YEARS OLD FOUND TO BE USING THIS SITE WILL
              HAVE ANY WINNINGS FORFEITED AND MAY ALSO BE REPORTED TO THE POLICE.
            </p>
          </div>

          {/* Filtering Systems */}
          <div className="space-y-2">
            <h3 className="font-bold text-[16px]">Filtering systems</h3>

            <p className="text-[16px] leading-[19px]">
              {appUrl} advises and encourages its customers to prevent minors from accessing
              gambling websites.
            </p>

            <p className="text-[16px] leading-[19px]">
              Filtering solutions allow parents to regulate access to the internet, based on chosen
              criteria. Parents can use filters to prevent their children from accessing, amongst
              other things, gambling websites. Because our pages are labelled, filtering solutions
              being used to prevent gambling access are able to detect our site content, and block
              our pages.
            </p>

            <p className="text-[16px] leading-[19px]">
              If you share your computer with friends or family who are under the legal age to
              register or bet with our site, please consider parental filtering solutions such as:
            </p>

            <p className="text-[16px]">
              Net Nanny™ — <span className="text-primary">www.netnanny.com</span>
            </p>

            <p className="text-[16px]">
              CyberPatrol — <span className="text-primary">www.cyberpatrol.com</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AgeRestrictionModal;
